import React, { useContext, useEffect, useState } from "react";
import { Link } from 'react-router-dom';
import HomeThreeSingleProject from '../../../../components/HomeThreeSingleProject/HomeThreeSingleProject';
import { FaMapMarkerAlt } from 'react-icons/fa';
import axios from "axios";


const HomeThreeProjects = () => {

      async function getCodes() {
         const url =
         "https://2dwholi3q9.execute-api.us-east-1.amazonaws.com/v1/landing";
         const headerKey = "BXzBQkPwc68ODdJOCzZ4K5uS7QuCsaB39zIO3mX2";
         const response = await axios.post(url, {
           headers: {
             "x-api-key": headerKey,
           },
         });
        console.log(response);
        return 0;
       };

   return (
      <>
         <section className="tp-project-area-three pt-20 pb-50">
            {/* <div className="tp-newsletter-area-three position-relative pb-115">
               <div className="container">
                  <div className="tp-newsletter-area-three-bg" data-background="assets/img/blog/newsletter-bg.jpg">
                     <div className="row justify-content-center align-items-center">
                        <div className="col-xl-4">
                           <div className="tp-newsletter-area-three-text">
                              <h2 className="tp-newsletter-area-three-title mb-20">Check Availability</h2>
                              <div className="tp-newsletter-radio mr-20">
                                 <input type="radio" id="test1" name="radio-group" defaultChecked />
                                    <label htmlFor="test1">Residential</label>
                              </div>
                              <div className="tp-newsletter-radio">
                                 <input type="radio" id="test2" name="radio-group"/>
                                    <label htmlFor="test2">Commercial</label>
                              </div>
                           </div>
                        </div>
                        <div className="col-xl-6">
                           <div className="tp-newsletter-area-three">
                              <form action="#">
                                 <input type="email" placeholder="Write your email"/>
                                    <span><i> <FaMapMarkerAlt /> </i> Enter Address</span>
                                    <button type="submit" className="theme-btn">
                                       <i className="flaticon-enter"></i> Subscribe</button>
                              </form>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div> */}
            {/* <div onClick={() => getCodes()}>
               <text>sasasas</text>
            </div> */}

            <div className="container">
               <div className="row align-items-center">
                  <div className="col-xl-4 col-lg-4 col-md-6">
                     <div className="tp-project-title-wrapper wow fadeInUp" data-wow-delay=".2s">
                        <div className=' pt-4'>
                           <h4 className="tp-section-title " >Event Gallery</h4>
                        </div>
                        <h5 className="tp-section-subtitle-three mb-45">
                           <a target="_blank" href='https://www.facebook.com/hashtag/neogrowthmsmefestival?__eep__=6&__cft__[0]=AZWojG3SACBLla_nDcoF-ITkTPim74JMX2-KlHY7_tZV1PwaYTyLjMXI5AfH0V3cTKUAA-4aogbchOl_RmoUAE5hRakN0v0YOyKBhWOGNNnVi6Xi37FrY-etZKM8KpNnsb5D4oEiDFOTLY_fMKD2oGgSk9k1PupYNV6ih2YS104XuJS8mQs3oTVwOWgH0JXQn7k&__tn__=*NK-R'>
                              #NeoGrowthMSMEFestival
                           </a>
                           </h5>
                        <div className="tp-project-title-btn">
                           <Link to="/event-gallery" className="yellow-btn" style={{borderRadius:"10px"}}><i className="flaticon-enter"></i> View More</Link>
                        </div>
                     </div>
                  </div>


                  <HomeThreeSingleProject column="4" columnTwo="6" image_num="1"
                  title="Award 1" subTitle="Award 1" />

                  <HomeThreeSingleProject column="4" columnTwo="6" image_num="2"
                  title="Award 2" subTitle="Award 2" />

                  <HomeThreeSingleProject column="4" columnTwo="6" image_num="3"
                  title="Award 3" subTitle="Award 3" />

                  <HomeThreeSingleProject column="8" columnTwo="12" image_num="4"
                  title="Award 4" subTitle="Award 4" />

               </div>
            </div>
         </section>
      </>
   );
};

export default HomeThreeProjects;